import React, {Component} from 'react';
import studiosLogo from './images/wnyc-studios.svg';
import fleasLogo from './images/fleas_small.png';
import pickleLogo from './images/pickle_small.png';
import apple from './images/buttons/apple-podcast.svg';
import google from './images/buttons/google-play.svg';
// import spotify from './images/buttons/spotify.svg';
import './vendor/font-awesome.min.css';
import './App.css';
import FontAwesome from 'react-fontawesome';
import fetchJsonp from 'fetch-jsonp';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      message: ''
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({value: event.target.value});
  }

  handleSubmit(event) {
    let url = 'https://nypublicradio.us5.list-manage.com/subscribe/post-json?u=4109fdd323aaac7078eadaa8f&amp;id=ea55851b6d&EMAIL=' + this.state.value;

    fetchJsonp(url, {jsonpCallback: 'c'}).then(response => response.json().then(data => {
      this.setState({message: data.msg});
      var noEmail  = '0 - Please enter a value';
      var singleAt = '0 - An email address must contain a single @';
      var domainInvalid = '0 - The domain portion of the email address is invalid (the portion after the @: ab)';
      if (data.msg === noEmail) {
        this.setState({ message: 'Whoops! You need to enter your email.' })
      } else if (data.msg === singleAt) {
        this.setState({ message: 'Whoops! Your email address should only contain one @' })
      } else if (data.msg === domainInvalid) {
        this.setState({ message: 'Whoops! The domain portion of the email address is invalid (the portion after the @: ab)' })
      }
    }
    ));
    event.preventDefault();
  }

  render() {
    return (
      <div className="page">
        <div className="background">
        <div className="box">

          <div className="box__top">

            <div className="box__header">
              <div className="box__title">
              <h3>New from WNYC Studios:</h3>
                <h1>Podcasts for Kids!</h1>
              </div>
            </div>

            <div className="box__description">
              <p>Finally, a good reason to give your kid the phone.  Gear up for comedy, stories, talk and more in our new slate of kids’ podcasts. We promise they will make your adult ears happy,&nbsp;too.</p>
            </div>

            <div className="box__podcast">
              <div className="podcast__logo">
                <a href="http://www.wnycstudios.org/shows/fleas" target="_blank" className="fleas__logo--anchor">
                  <img src={fleasLogo} alt="This Podcast Has Fleas logo"/>
                </a>
              </div>
              
              <div className="podcast__body">
                <p className="podcast__title"><a href="http://www.wnycstudios.org/shows/fleas" target="_blank">This Podcast Has Fleas</a></p>
                <p>What happens when rival pets have dueling podcasts? Find out in this original comedy series for kids, starring a dog and a cat who are always trying to get the upper paw. Gerbil and goldfish also included.</p>
              </div>
            </div>


          <div className="box__buttons">
            <a href="https://itunes.apple.com/us/podcast/id1318397377" target="_blank"
               title="Listen to the podcast on Apple Podcast">
              <img src={apple} alt="Listen to the podcast on Apple Podcast"
               className="clicked__fleas__apple-podcast btn__spacer" />
            </a>
            <a href="https://play.google.com/music/listen?u=0#/ps/I5mjpqk3sv5giom2j5bbjpisg3e" target="_blank"
               title="Listen to the podcast on Google Play">
              <img src={google} alt="Listen to the podcast on Google Play"
               className="clicked__fleas__google-play btn__spacer" />
            </a>

          </div>

            <div className="box__podcast">
              <div className="podcast__logo">
                <a href="http://www.wnycstudios.org/shows/pickle" target="_blank" className="fleas__logo--anchor">
                  <img src={pickleLogo} alt="Pickle logo"/>
                </a>
              </div>
              
              <div className="podcast__body">
                <p className="podcast__title"><a href="http://www.wnycstudios.org/shows/pickle" target="_blank">Pickle</a></p>
                <p>Explore life’s trickiest questions with curious kids―and the occasional elephant!</p>
              </div>
            </div>

            <div className="box__buttons">
              <a href="https://itunes.apple.com/us/podcast/id1322135070" target="_blank"
                 title="Listen to the podcast on Apple Podcast">
                <img src={apple} alt="Listen to the podcast on Apple Podcast"
                 className="clicked__pickle__apple-podcast btn__spacer" />
              </a>
              <a href="https://play.google.com/music/listen?u=0#/ps/I3fdt4pklt77a7is6x2nqcmjxhy" target="_blank"
                 title="Listen to the podcast on Google Play">
                <img src={google} alt="Listen to the podcast on Google Play"
                 className="clicked__pickle__google-play btn__spacer" />
              </a>

            </div>

          </div>
          <div className="box__bottom">

            <div className="box__newsletter">
              <div className="mailchimp-form">
                <form onSubmit={this.handleSubmit}>
                  <label>
                    <input placeholder="Enter your email" type="email" value={this.state.value} onChange={this.handleChange}/>
                  </label>
                  <input type="submit" value="Sign up" className="clicked__wnyckids__newsletter" />
                </form>
                <div className="box__newsletter--error clicked__wnyckids__update-newsletter-profile" dangerouslySetInnerHTML={{ __html: this.state.message }}/></div>
              </div>

              <div className="box__footer">
                <a href="https://www.facebook.com/wnyckids/" target="_blank"
                   className="link--white clicked__wnyckids__facebook-page">
                  <FontAwesome name='facebook'/>
                  Facebook
                </a>
                <a href="https://twitter.com/wnyckids" target="_blank"
                   className="link--white clicked__wnyckids__twitter-page">
                  <FontAwesome name='twitter'/>
                  Twitter
                </a>
              </div>
            </div>
          </div>


      </div>

      <div className="inner">
      <div className="sponsor">
            <a href="http://wnycstudios.wnyc.org/" target="_blank">
              <img src={studiosLogo} alt="WNYC Studios logo"
             className="clicked__wnyckids__wnycstudios-header btn__spacer--bigger" />
            </a>
      </div>
      <div>&copy; 2017 <a href="http://wnycstudios.wnyc.org/" target="_blank" className="clicked__wnyckids__wnycstudios-footer">WNYC Studios</a>.</div>
      </div>
    </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js